<template>
  <div class="main_form_body main_form_body_voteBasic">
    <div class="form_bar" style="align-self: flex-end; width: 100%">
      <div class="form_bar_search"></div>
      <div class="form_bar_btn">
        <el-button type="text" @click="goBack()">投票列表</el-button>
        <el-button
          type="primary"
          @click="editVote('voteBasicForm', false)"
          size="small"
          :disabled="voteInfo.Status !== 0"
        >
          保存
        </el-button>
        <el-button
          type="primary"
          @click="editVote('voteBasicForm', true)"
          size="small"
          :disabled="voteInfo.Status !== 0"
        >
          下一步
        </el-button>
      </div>
    </div>
    <div class="form_content" style="flex-grow: 1; width: 100%">
      <div class="main_form">
        <el-form
          :model="voteBasicForm"
          :rules="voteBasicFormRules"
          ref="voteBasicForm"
          label-width="120px"
          class="demo-ruleForm"
          v-loading="editVoteLoading"
          :disabled="voteInfo.Status !== 0"
          :label-position="is_xs ? 'top' : 'right'"
        >
          <el-form-item label="投票名称" prop="VoteName">
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-input v-model="voteBasicForm.VoteName"></el-input>
                <br />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="投票时间"
            required
            v-if="meetingInfo.MeetingType === 2"
          >
            <el-col :xs="11" :sm="8" :md="8" :lg="6" :xl="3">
              <el-form-item class="el-form-item-internal" prop="StartTime">
                <el-date-picker
                  ref="StartTime"
                  type="datetime"
                  placeholder="选择开始日期时间"
                  v-model="voteBasicForm.StartTime"
                  format="yyyy-MM-dd HH:mm"
                  default-time="9:00:00"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :xs="2" :sm="2" :md="2" :lg="1" :xl="1">
              -
            </el-col>
            <el-col :xs="11" :sm="8" :md="8" :lg="6" :xl="3">
              <el-form-item class="el-form-item-internal" prop="EndTime">
                <el-date-picker
                  ref="EndTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                  v-model="voteBasicForm.EndTime"
                  format="yyyy-MM-dd HH:mm"
                  default-time="18:00:00"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item
            label="投票规则"
            prop="Remark"
            v-if="meetingInfo.MeetingType === 2"
          >
            <el-row>
              <el-col :xs="24" :sm="24" :md="18" :lg="14" :xl="14">
                <el-input
                  ref="Remark"
                  type="textarea"
                  rows="5"
                  v-model="voteBasicForm.Remark"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            label="投票方式"
            prop="VoteType"
            v-if="meetingInfo.MeetingType === 0"
          >
            <div class="vote_mode">
              <div class="vote_mode_item">
                <a @click="selectMode(0)">
                  <img :src="ruweiUrl" />
                </a>
                <span>入围</span>
              </div>
              <div class="vote_mode_item">
                <a @click="selectMode(1)">
                  <img :src="paixuUrl" />
                </a>
                <span>排序</span>
              </div>
              <div class="vote_mode_item">
                <a @click="selectMode(2)">
                  <img :src="dafenUrl" />
                </a>
                <span>打分</span>
              </div>
              <div class="vote_mode_item">
                <a @click="selectMode(5)">
                  <img :src="wejuanUrl" />
                </a>
                <span>问卷</span>
              </div>
              <div class="vote_mode_item">
                <div class="vote_type_divider_box">
                  <el-divider direction="vertical" class="vote_type_divider"
                    >投屏</el-divider
                  >
                  <span>投屏</span>
                </div>
              </div>
              <div class="vote_mode_item">
                <a @click="selectMode(4)">
                  <img :src="ruweiScreenUrl" />
                </a>
                <span>入围投屏</span>
              </div>
              <div class="vote_mode_item" v-if="voteInfo.MeetingVerify !== 1">
                <a @click="selectMode(3)">
                  <img :src="toupinUrl" />
                </a>
                <span>打分投屏</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="投票规则"
            v-if="voteBasicForm.VoteType !== 1 && false"
          >
            <el-radio-group
              v-model="voteBasicForm.BindRuleType"
              size="small"
              @change="bingRuleTypeChange"
            >
              <el-radio-button label="from">编辑规则</el-radio-button>
              <el-radio-button label="select">已有规则</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <div
            label=""
            prop="SelectRuleId"
            v-if="
              voteBasicForm.VoteType !== 1 &&
              voteBasicForm.BindRuleType === 'from'
            "
          >
            <el-form-item
              label="规则名称"
              prop="RuWeiRule.Name"
              v-show="voteBasicForm.VoteType === 0"
              v-if="meetingInfo.MeetingType === 0 && !voteBasicForm.IsScreen"
            >
              <el-select
                v-model="voteBasicForm.RuWeiRule"
                value-key="Id"
                ref="RuWeiSelectRuleList"
                filterable
                allow-create
                default-first-option
                placeholder="请输入规则名称"
                @change="ruleChange"
                @blur="ruleBlur"
                :filter-method="dataFilter"
              >
                <el-option
                  v-for="(item, index) in ruweiTable"
                  :key="index"
                  :label="item.Name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="规则名称"
              prop="DaFenRule.Name"
              v-show="voteBasicForm.VoteType === 2"
            >
              <el-select
                v-model="voteBasicForm.DaFenRule"
                value-key="Id"
                ref="DaFenSelectRuleList"
                filterable
                allow-create
                default-first-option
                placeholder="请输入规则名称"
                @change="ruleChange"
                @blur="ruleBlur"
                :filter-method="dataFilter"
              >
                <el-option
                  v-for="(item, index) in ruweiTable"
                  :key="index"
                  :label="item.Name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="规则名称"
              prop="ScreenRule.Name"
              v-show="voteBasicForm.VoteType === 3"
            >
              <el-select
                v-model="voteBasicForm.ScreenRule"
                value-key="Id"
                ref="screenSelectRuleList"
                filterable
                allow-create
                default-first-option
                placeholder="请输入规则名称"
                @change="ruleChange"
                @blur="ruleBlur"
                :filter-method="dataFilter"
              >
                <el-option
                  v-for="(item, index) in ruweiTable"
                  :key="index"
                  :label="item.Name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="vote_fraction_box"
              label="通过方式"
              v-if="
                voteBasicForm.VoteType === 0 &&
                meetingInfo.MeetingType === 0 &&
                !voteBasicForm.IsScreen
              "
              required
            >
              <div class="form_item_inline">
                <el-form-item
                  class="el-form-item-internal"
                  prop="RuWeiRule.PassOperator"
                >
                  <el-select
                    class="form_item_inline_select"
                    v-model="voteBasicForm.RuWeiRule.PassOperator"
                    @change="$forceUpdate()"
                  >
                    <el-option label="大于等于" value="0"></el-option>
                    <el-option label="大于" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <div class="fraction_group">
                  <el-form-item
                    class="el-form-item-internal fraction_number"
                    prop="RuWeiRule.PassValue_start"
                    :inline-message="true"
                  >
                    <el-input-number
                      v-model="voteBasicForm.RuWeiRule.PassValue_start"
                      controls-position="right"
                      :precision="0"
                      :step="1"
                      :min="1"
                      :max="1000"
                      style="width: 80px"
                      :controls="false"
                      @blur="passValueChange"
                    ></el-input-number>
                  </el-form-item>
                  <el-divider class="fraction_divider"></el-divider>
                  <el-form-item
                    class="el-form-item-internal fraction_number"
                    prop="RuWeiRule.PassValue_end"
                    :inline-message="true"
                  >
                    <el-input-number
                      v-model="voteBasicForm.RuWeiRule.PassValue_end"
                      controls-position="right"
                      :precision="0"
                      :step="1"
                      :min="1"
                      :max="1000"
                      style="width: 80px"
                      :controls="false"
                      @blur="passValueChange"
                    ></el-input-number>
                  </el-form-item>
                </div>
                <span
                  class="fraction_percent hidden-sm-and-down"
                  v-show="rolePercent"
                  >（通过率：{{ rolePercent }}）</span
                >
              </div>
            </el-form-item>
            <el-form-item
              label="去掉最高分"
              v-if="voteBasicForm.VoteType === 2"
            >
              <el-switch
                v-model="voteBasicForm.DaFenRule.DeleteMaxScore"
                @change="$forceUpdate()"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="去掉最低分"
              v-if="voteBasicForm.VoteType === 2"
            >
              <el-switch
                v-model="voteBasicForm.DaFenRule.DeleteMinScore"
                @change="$forceUpdate()"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="显示评委信息"
              v-if="voteBasicForm.VoteType === 3"
            >
              <el-switch
                v-model="voteBasicForm.ScreenRule.IsAnony"
                @change="$forceUpdate()"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="去掉最高分"
              v-if="voteBasicForm.VoteType === 3"
            >
              <el-switch
                v-model="voteBasicForm.ScreenRule.IsRemoveMaxScore"
                @change="$forceUpdate()"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="去掉最低分"
              v-show="voteBasicForm.VoteType === 3"
            >
              <el-switch
                v-model="voteBasicForm.ScreenRule.IsRemoveMinScore"
                @change="$forceUpdate()"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="是否分细项打分"
              v-show="voteBasicForm.VoteType === 3"
            >
              <el-switch
                v-model="voteBasicForm.ScreenRule.IsDetailRule"
                @change="$forceUpdate()"
              ></el-switch>
            </el-form-item>
            <el-form-item
              label="最低分数："
              v-show="
                voteBasicForm.VoteType === 3 &&
                !voteBasicForm.ScreenRule.IsDetailRule
              "
              prop="MinScore"
            >
              <el-input-number
                v-model="voteBasicForm.ScreenRule.MinScore"
                controls-position="right"
                :min="0"
                size="mini"
                :precision="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="最高分数："
              v-show="
                voteBasicForm.VoteType === 3 &&
                !voteBasicForm.ScreenRule.IsDetailRule
              "
              prop="MaxScore"
            >
              <el-input-number
                v-model="voteBasicForm.ScreenRule.MaxScore"
                controls-position="right"
                :min="0"
                size="mini"
                :precision="0"
                :step="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="显示顺序"
              v-if="voteBasicForm.VoteType === 0 && false"
            >
              <el-col
                :xs="{ span: 24 }"
                :sm="{ span: 16 }"
                :md="{ span: 8 }"
                :lg="{ span: 6 }"
                :xl="{ span: 6 }"
              >
                <el-form-item
                  class="el-form-item-internal"
                  prop="RuWeiRule.Sort"
                >
                  <el-input
                    v-model="voteBasicForm.RuWeiRule.Sort"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    :max="1000000"
                    autocomplete="off"
                    placeholder="请输入排序序号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item
              label="显示顺序"
              v-if="voteBasicForm.VoteType === 2 && false"
            >
              <el-col
                :xs="{ span: 24 }"
                :sm="{ span: 16 }"
                :md="{ span: 8 }"
                :lg="{ span: 6 }"
                :xl="{ span: 6 }"
              >
                <el-form-item
                  class="el-form-item-internal"
                  prop="DaFenRule.Sort"
                >
                  <el-input
                    v-model="voteBasicForm.DaFenRule.Sort"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    :max="1000000"
                    autocomplete="off"
                    placeholder="请输入排序序号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item
              label="显示顺序"
              v-if="voteBasicForm.VoteType === 3 && false"
            >
              <el-col
                :xs="{ span: 24 }"
                :sm="{ span: 16 }"
                :md="{ span: 8 }"
                :lg="{ span: 6 }"
                :xl="{ span: 6 }"
              >
                <el-form-item
                  class="el-form-item-internal"
                  prop="ScreenRule.Sort"
                >
                  <el-input
                    v-model="voteBasicForm.ScreenRule.Sort"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    :max="1000000"
                    autocomplete="off"
                    placeholder="请输入排序序号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item
              label="细则"
              v-if="
                voteBasicForm.VoteType === 2 ||
                (voteBasicForm.VoteType === 3 &&
                  voteBasicForm.ScreenRule.IsDetailRule)
              "
            >
              <el-dialog
                top="40px"
                :title="ruleItemForm.Id == null ? '新增细则' : '编辑细则'"
                :visible.sync="innerVisible"
                :close-on-click-modal="false"
                append-to-body
                custom-class="custom_dialog"
              >
                <div
                  class="dialog_body_box"
                  style="max-height: 580px; overflow-y: auto"
                >
                  <el-form
                    :model="ruleItemForm"
                    :rules="ruleItemFormRules"
                    ref="ruleItemForm"
                    label-width="110px"
                    class="demo-ruleForm"
                    size="mini"
                    :label-position="is_xs ? 'top' : 'right'"
                  >
                    <el-form-item label="细则名称：" prop="Title">
                      <el-input
                        v-model="ruleItemForm.Title"
                        autocomplete="off"
                        placeholder="请输入细则名称"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="细则内容：" prop="Content">
                      <VueUeditorWrap
                        ref="contentUeditor"
                        v-model="ruleItemForm.Content"
                        :config="ueditorConfig"
                      ></VueUeditorWrap>
                    </el-form-item>
                    <el-form-item label="是否打分项：" prop="IsScoringItem">
                      <el-switch
                        v-model="ruleItemForm.IsScoringItem"
                        @change="$forceUpdate()"
                      ></el-switch>
                    </el-form-item>
                    <el-form-item
                      label="最低分数："
                      prop="MinScore"
                      v-show="ruleItemForm.IsScoringItem"
                    >
                      <el-input-number
                        v-model="ruleItemForm.MinScore"
                        controls-position="right"
                        :min="0"
                        size="mini"
                        :precision="0"
                        :step="1"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      label="最高分数："
                      prop="MaxScore"
                      v-show="ruleItemForm.IsScoringItem"
                    >
                      <el-input-number
                        v-model="ruleItemForm.MaxScore"
                        controls-position="right"
                        :min="0"
                        size="mini"
                        :precision="0"
                        :step="1"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      label="权重百分比："
                      prop="ScorePercent"
                      v-show="ruleItemForm.IsScoringItem"
                    >
                      <el-input-number
                        v-model="ruleItemForm.ScorePercent"
                        controls-position="right"
                        :min="0"
                        size="mini"
                        :precision="2"
                        :step="1"
                      ></el-input-number>
                      %
                    </el-form-item>
                    <el-form-item label="显示顺序：">
                      <el-col :span="16">
                        <el-form-item class="el-form-item-internal" prop="Sort">
                          <el-input
                            v-model="ruleItemForm.Sort"
                            oninput="value=value.replace(/[^\d]/g,'')"
                            :max="1000000"
                            autocomplete="off"
                            placeholder="请输入排序序号"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                  </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="innerVisible = false">取 消</el-button>
                  <el-button
                    type="primary"
                    @click="editRuleItem('ruleItemForm')"
                    >确 定</el-button
                  >
                </div>
              </el-dialog>
              <div class="table-block">
                <div class="operate_btn_box">
                  <span style="font-size: 12px; flex-grow: 1; color: red">
                    无细分项情况下，至少需要一项细则。
                  </span>
                  <el-button
                    type="success"
                    @click="openEditRuleItem(null, 'add', 0)"
                  >
                    新增细则
                  </el-button>
                </div>
                <el-table
                  :data="voteBasicForm.DaFenRule.RuleItems"
                  style="width: 100%"
                >
                  <el-table-column type="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    property="Title"
                    label="细则名称"
                    width="120"
                  >
                  </el-table-column>
                  <el-table-column label="细则内容" key="ContentText">
                    <template slot-scope="scope">
                      <span>{{ scope.row.ContentText }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="是否打分项"
                    width="120"
                    align="center"
                    key="IsScoringItem"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.IsScoringItem">是</span>
                      <span v-if="!scope.row.IsScoringItem">否</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分数范围"
                    width="90"
                    align="center"
                    key="Score"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.IsScoringItem">
                        {{ scope.row.MinScore }}~{{ scope.row.MaxScore }}
                      </span>
                      <span v-if="!scope.row.IsScoringItem"> 无 </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="权重"
                    width="90"
                    align="center"
                    key="ScorePercent"
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.IsScoringItem">
                        {{ scope.row.ScorePercent }}%
                      </span>
                      <span v-if="!scope.row.IsScoringItem"> 无 </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="排序"
                    width="50"
                    align="center"
                    key="Sort"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.Sort }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                      <el-link
                        type="primary"
                        class="cell_link"
                        @click.stop
                        @click="
                          openEditRuleItem(scope.row, 'edit', scope.$index)
                        "
                      >
                        编辑
                      </el-link>
                      <el-link
                        type="primary"
                        class="cell_link"
                        @click.stop
                        @click="deleteRuleItem(scope.row, scope.$index)"
                      >
                        删除
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label=""
            prop="SelectRuleId"
            v-if="
              voteBasicForm.VoteType !== 1 &&
              voteBasicForm.BindRuleType === 'select'
            "
          >
            <!-- <el-divider id="selectRule" content-position="left">
              {{ selectRuleName }}
            </el-divider> -->
            <div class="table-block">
              <el-button
                type="primary"
                @click="editRule(null)"
                class="margin_right_10"
                plain
              >
                新增规则
              </el-button>
              <span class="select_message">
                {{ selectRuleName }}
              </span>
              <el-table
                v-loading="ruleTableLoading"
                ref="singleRuweiTable"
                :data="ruweiTable"
                highlight-current-row
                @current-change="selectRowChange"
                style="width: 100%"
              >
                <el-table-column type="index" width="50">
                  <template slot-scope="scope">
                    <i
                      v-if="scope.row.Id === voteBasicForm.SelectRuleId"
                      style="color: #66b1ff; font-size: 16px; font-weight: 600"
                      class="el-icon-check"
                    ></i>
                  </template>
                </el-table-column>
                <el-table-column property="Name" label="规则名称">
                </el-table-column>
                <el-table-column
                  label="通过方式"
                  width="120"
                  align="center"
                  v-if="voteBasicForm.VoteType === 0"
                  key="PassOperatorText"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.PassOperatorText }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="通过率"
                  width="120"
                  align="center"
                  v-if="voteBasicForm.VoteType === 0"
                  key="PassValue"
                >
                  <template slot-scope="scope">
                    <span>{{ scope.row.PassValue }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="去掉最高分"
                  width="120"
                  align="center"
                  v-if="voteBasicForm.VoteType === 2"
                  key="DeleteMaxScore"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.DeleteMaxScore">是</span>
                    <span v-if="!scope.row.DeleteMaxScore">否</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="去掉最低分"
                  width="120"
                  align="center"
                  v-if="voteBasicForm.VoteType === 2"
                  key="DeleteMinScore"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.DeleteMinScore">是</span>
                    <span v-if="!scope.row.DeleteMinScore">否</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="显示评委信息"
                  width="120"
                  align="center"
                  v-if="voteBasicForm.VoteType === 3"
                  key="IsAnony"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.IsAnony">是</span>
                    <span v-if="!scope.row.IsAnony">否</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="是否去掉最高分"
                  width="120"
                  align="center"
                  v-if="voteBasicForm.VoteType === 3"
                  key="IsRemoveMaxScore"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.IsRemoveMaxScore">是</span>
                    <span v-if="!scope.row.IsRemoveMaxScore">否</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="是否去掉最低分"
                  width="120"
                  align="center"
                  v-if="voteBasicForm.VoteType === 3"
                  key="IsRemoveMinScore"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.IsRemoveMinScore">是</span>
                    <span v-if="!scope.row.IsRemoveMinScore">否</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      class="cell_link"
                      @click.stop
                      @click="editRule(scope.row.Id)"
                    >
                      编辑
                    </el-link>
                    <el-link
                      type="primary"
                      class="cell_link"
                      @click.stop
                      @click="deleteRule(scope.row)"
                    >
                      删除
                    </el-link>
                    <el-link
                      type="primary"
                      class="cell_link"
                      v-if="voteBasicForm.VoteType === 2"
                      @click.stop
                      @click="ruleItemManager(scope.row.Id)"
                    >
                      细则管理
                    </el-link>
                    <el-link
                      type="primary"
                      class="cell_link"
                      v-if="
                        voteBasicForm.VoteType === 0 ||
                        voteBasicForm.VoteType === 2
                      "
                      @click.stop
                      @click="editRuleDetails(scope.row.Id)"
                    >
                      介绍
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <EditRule
        :meetId="voteBasicForm.MeetId"
        :ruleType="voteBasicForm.VoteType"
        :fatherSubmitDialog="submitRuleDialog"
        ref="editRule"
      ></EditRule>
      <EditRuleDetails ref="editRuleDetails"></EditRuleDetails>
      <EditRuleItems ref="editRuleItems"></EditRuleItems>
    </div>
    <div class="vote_type_desc" v-if="meetingInfo.MeetingType === 0">
      投票方式介绍：
      <br />
      入围：从多个参赛作品、项目、人员中最终评出最终入选结果，按得票数由高到低进行排列；
      <br />
      排序：对参赛作品、项目、人员进行排序，计算最终排序结果；
      <br />
      打分：按照打分标准对作品、项目、人员进行多维度打分，最终汇总平均分降序排列；
      <br />
      投屏：现场打分投票，大屏幕实时展示投票信息。
      <br />
      更多投票方式欢迎提出改进建议
    </div>
  </div>
</template>

<script>
import voteRuleApi from '../../../api/vote/voteRule'
import voteManageApi from '../../../api/vote/voteManage'
import EditRule from '@/components/rule/EditRule.vue'
import EditRuleDetails from '@/components/rule/EditRuleDetails.vue'
import EditRuleItems from '@/components/rule/EditRuleItems.vue'
import ueditorConfig from '../../../assets/js/ueditorConfig'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  components: {
    EditRule,
    EditRuleDetails,
    EditRuleItems,
    VueUeditorWrap
  },
  data () {
    const _this = this
    const validateSort = (rule, value, callback) => {
      if (value >= 1000000) {
        callback(new Error('排序值必须小于7位数！'))
      } else {
        callback()
      }
    }
    const ruweiRuleNameValidate = (rule, value, callback) => {
      if (_this.voteBasicForm.VoteType === 0) {
        if (!value) {
          callback(new Error('请输入规则名称'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const daFenRuleNameValidate = (rule, value, callback) => {
      if (_this.voteBasicForm.VoteType === 2) {
        if (!value) {
          callback(new Error('请输入规则名称'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const screenRuleNameValidate = (rule, value, callback) => {
      if (_this.voteBasicForm.VoteType === 3) {
        if (!value) {
          callback(new Error('请输入规则名称'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      ruweiUrl: require('../../../assets/images/vote/selectedIcon.png'),
      paixuUrl: require('../../../assets/images/vote/reorderIcon.png'),
      dafenUrl: require('../../../assets/images/vote/scoredIcon.png'),
      toupinUrl: require('../../../assets/images/vote/scoredIcon.png'),
      ruweiScreenUrl: require('../../../assets/images/vote/selectedIcon.png'),
      wejuanUrl: require('../../../assets/images/vote/qaIconFocus.png'),
      editVoteLoading: true,
      ruleTableLoading: false,
      voteBasicForm: {
        Id: null,
        VoteName: null,
        MeetId: null,
        VoteType: null,
        SelectRuleId: null,
        BindRuleType: 'from',
        ScreenRule: { Id: null, IsDetailRule: false, RuleItems: [], DeleteRuleItemIds: [] },
        RuWeiRule: { Id: null },
        DaFenRule: { Id: null, RuleItems: [], DeleteRuleItemIds: [] },
        StartTime: '',
        EndTime: '',
        Remark: '',
        IsScreen: false
      },
      rolePercent: '',
      voteBasicFormRules: {
        VoteName: [
          { required: true, message: '请输入投票名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
        VoteType: [
          { required: true, message: '请选择会议类型', trigger: 'blur' }],
        SelectRuleId: [
          { required: true, message: '请选择投票规则', trigger: 'blur' }],
        'RuWeiRule.Name': [
          { validator: ruweiRuleNameValidate, trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        'DaFenRule.Name': [
          { validator: daFenRuleNameValidate, trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        'ScreenRule.Name': [
          { validator: screenRuleNameValidate, trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        'RuWeiRule.Sort': [
          { validator: validateSort, trigger: 'blur' }],
        'DaFenRule.Sort': [
          { validator: validateSort, trigger: 'blur' }],
        'ScreenRule.Sort': [
          { validator: validateSort, trigger: 'blur' }],
        'RuWeiRule.PassValue_start': [
          { required: true, message: '请输入通过率', trigger: 'blur' }],
        'RuWeiRule.PassValue_end': [
          { required: true, message: '请输入通过率', trigger: 'blur' }],
        StartTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        EndTime: [{ required: true, message: '请选择时间', trigger: 'change' }],
        Remark: [{ min: 0, max: 4000, message: '最多4000个字符', trigger: 'blur' }]
      },
      ruleListQuery: {
        meetingId: null,
        ruleType: 0,
        maxResultCount: 10000,
        skipCount: 0
      },
      ruweiTable: [],
      selectRuleName: '选择投票规则',
      inputRuleName: '',
      ruleItemAction: 'add',
      ruleItemIndex: 0,
      ruleItemForm: {},
      ruleItemFormRules: {
        Title: [
          { required: true, message: '请输入细则名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度最多50个字符。', trigger: 'blur' }],
        MinScore: [
          { required: true, message: '请输入最低分数', trigger: 'blur' }],
        MaxScore: [
          { required: true, message: '请输入最高分数', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (_this.ruleItemForm.MinScore > value) {
                callback(new Error('最高分必须大于最低分！'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }],
        ScorePercent: [
          { required: true, message: '请输入权重百分比', trigger: 'blur' }],
        Sort: [
          { validator: validateSort, trigger: 'blur' }]
      },
      innerVisible: false,
      ueditorConfig: ueditorConfig
    }
  },
  props: ['voteInfo', 'meetingInfo'],
  inject: ['voteCheck', 'getVoteInfo', 'routeChange'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getScreenRules: function () {
      const _this = this
      this.editVoteLoading = true
      voteRuleApi.getScreenRules({
        meetingId: this.ruleListQuery.meetingId,
        ruleType: this.ruleListQuery.ruleType,
        skipCount: this.ruleListQuery.skipCount,
        maxResultCount: this.ruleListQuery.maxResultCount
      })
        .then(data => {
          this.ruweiTable = data.Items
          // _this.voteBasicForm.ScreenRule = {}
          this.ruweiTable.forEach(function (item, index) {
            if (item.Id.toLowerCase() === _this.voteBasicForm.SelectRuleId.toLowerCase()) {
              if (_this.voteBasicForm.BindRuleType === 'select') {
                _this.$refs.singleRuweiTable.setCurrentRow(item)
              }
              if (_this.voteBasicForm.BindRuleType === 'from') {
                _this.voteBasicForm.ScreenRule = item
              }
            }
          })
          if (this.inputRuleName.length > 0) {
            this.ruleChange(this.inputRuleName)
          }
          this.editVoteLoading = false
        }).catch(err => {
          this.editVoteLoading = false
          return err
        })
    },
    getRules: function () {
      const _this = this
      _this.editVoteLoading = true
      voteRuleApi.getRules({
        meetingId: _this.ruleListQuery.meetingId,
        ruleType: _this.ruleListQuery.ruleType,
        skipCount: _this.ruleListQuery.skipCount,
        maxResultCount: _this.ruleListQuery.maxResultCount
      }).then(data => {
        _this.ruweiTable = data.Items
        // if (_this.voteBasicForm.VoteType === 0) {
        //   _this.voteBasicForm.RuWeiRule = {}
        // }
        // if (_this.voteBasicForm.VoteType === 2) {
        //   _this.voteBasicForm.DaFenRule = {}
        // }
        _this.ruweiTable.forEach(function (item, index) {
          if (item.Id.toLowerCase() === _this.voteBasicForm.SelectRuleId.toLowerCase()) {
            if (_this.voteBasicForm.BindRuleType === 'select') {
              _this.$refs.singleRuweiTable.setCurrentRow(item)
            }
            if (_this.voteBasicForm.BindRuleType === 'from') {
              // _this.voteBasicForm.RuWeiRule = item
            }
          }
        })
        if (this.inputRuleName.length > 0) {
          this.ruleChange(this.inputRuleName)
        }
        _this.editVoteLoading = false
      }).catch(err => {
        _this.editVoteLoading = false
        return err
      })
    },
    getVoteBasicInfo: function () {
      this.editVoteLoading = true
      voteManageApi.getVoteBasicInfo({
        voteId: this.$route.params.vid
      }).then(data => {
        this.voteBasicForm = data
        if (this.voteBasicForm.ScreenRule === null) {
          this.voteBasicForm.ScreenRule = {}
        }
        if (this.voteBasicForm.RuWeiRule === null) {
          this.voteBasicForm.RuWeiRule = {}
        }
        if (this.voteBasicForm.DaFenRule === null) {
          this.voteBasicForm.DaFenRule = {}
        }
        if (data.VoteType === 0) {
          if (data.IsScreen) {
            this.selectMode(4)
          } else {
            this.selectMode(data.VoteType)
          }
        } else {
          this.selectMode(data.VoteType)
        }
      }).catch(err => {
        this.editVoteLoading = false
        return err
      })
    },
    selectMode: function (selectIndex) {
      this.editVoteLoading = true
      this.voteBasicForm.VoteType = selectIndex
      if (selectIndex === 4) {
        this.voteBasicForm.VoteType = 0
        this.voteBasicForm.IsScreen = true
      } else {
        this.voteBasicForm.IsScreen = false
      }
      this.ruleListQuery.skipCount = 0
      this.ruleListQuery.ruleType = selectIndex
      if (selectIndex === 4) {
        this.ruleListQuery.ruleType = this.voteBasicForm.VoteType
      }
      // this.inputRuleName = ''
      switch (selectIndex) {
        case 0:
          this.ruweiUrl = require('../../../assets/images/vote/selectedIconFocus.png')
          this.paixuUrl = require('../../../assets/images/vote/reorderIcon.png')
          this.dafenUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.toupinUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.ruweiScreenUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.wejuanUrl = require('../../../assets/images/vote/qaIcon.png')
          this.getRules()
          this.passValueChange()
          break
        case 1:
          this.ruweiUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.paixuUrl = require('../../../assets/images/vote/reorderIconFocus.png')
          this.dafenUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.toupinUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.ruweiScreenUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.wejuanUrl = require('../../../assets/images/vote/qaIcon.png')
          this.ruweiTable = []
          this.editVoteLoading = false
          break
        case 2:
          this.ruweiUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.paixuUrl = require('../../../assets/images/vote/reorderIcon.png')
          this.dafenUrl = require('../../../assets/images/vote/scoredIconFocus.png')
          this.toupinUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.ruweiScreenUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.wejuanUrl = require('../../../assets/images/vote/qaIcon.png')
          this.getRules()
          break
        case 3:
          this.ruweiUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.paixuUrl = require('../../../assets/images/vote/reorderIcon.png')
          this.dafenUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.toupinUrl = require('../../../assets/images/vote/scoredIconFocus.png')
          this.ruweiScreenUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.wejuanUrl = require('../../../assets/images/vote/qaIcon.png')
          this.getScreenRules()
          break
        case 4:
          this.ruweiUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.paixuUrl = require('../../../assets/images/vote/reorderIcon.png')
          this.dafenUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.toupinUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.ruweiScreenUrl = require('../../../assets/images/vote/selectedIconFocus.png')
          this.wejuanUrl = require('../../../assets/images/vote/qaIcon.png')
          this.inputRuleName = this.voteBasicForm.VoteName
          if (this.inputRuleName && this.inputRuleName.length > 0) {
            this.ruleChange(this.inputRuleName)
          }
          //   this.voteBasicForm.RuWeiRule.PassOperator = '0'
          //   this.voteBasicForm.RuWeiRule.PassValue_start = 1
          //   this.voteBasicForm.RuWeiRule.PassValue_end = 1
          this.getRules()
          this.passValueChange()
          break
        case 5:
          this.ruweiUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.paixuUrl = require('../../../assets/images/vote/reorderIcon.png')
          this.dafenUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.toupinUrl = require('../../../assets/images/vote/scoredIcon.png')
          this.ruweiScreenUrl = require('../../../assets/images/vote/selectedIcon.png')
          this.wejuanUrl = require('../../../assets/images/vote/qaIconFocus.png')
          this.ruweiTable = []
          this.editVoteLoading = false
      }
    },
    selectRowChange: function (row) {
      if (row) {
        this.voteBasicForm.SelectRuleId = row.Id
        this.selectRuleName = '已选规则：' + row.Name
      } else {
        this.voteBasicForm.SelectRuleId = null
        this.selectRuleName = '选择投票规则'
      }
    },
    editVote: function (formName, isNext) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          const openLoading = _this.openLoading('正在保存…')
          if (_this.voteBasicForm.VoteType === 0) {
            if (this.voteBasicForm.IsScreen) {
              this.inputRuleName = this.voteBasicForm.VoteName
              if (this.inputRuleName && this.inputRuleName.length > 0) {
                this.ruleChange(this.inputRuleName)
              }
            }
            _this.voteBasicForm.RuWeiRule.MeetId = _this.voteBasicForm.MeetId
            _this.voteBasicForm.RuWeiRule.Type = _this.voteBasicForm.VoteType
          }
          if (_this.voteBasicForm.VoteType === 2) {
            if (_this.voteBasicForm.DaFenRule.RuleItems.length === 0) {
              _this.$message({
                showClose: true,
                type: 'warning',
                message: '无细分项情况下，至少需要一项细则。',
                customClass: 'custom_message'
              })
              openLoading.close()
              return
            }
            _this.voteBasicForm.DaFenRule.MeetId = _this.voteBasicForm.MeetId
            _this.voteBasicForm.DaFenRule.Type = _this.voteBasicForm.VoteType
          }
          if (_this.voteBasicForm.VoteType === 3) {
            _this.voteBasicForm.ScreenRule.MeetId = _this.voteBasicForm.MeetId
            _this.voteBasicForm.ScreenRule.Type = _this.voteBasicForm.VoteType
          }
          if (_this.meetingInfo.meetingType === 0) {
            _this.voteBasicForm.StartTime = _this.$moment(_this.voteBasicForm.StartTime).format('YYYY-MM-DD HH:mm')
            _this.voteBasicForm.EndTime = _this.$moment(_this.voteBasicForm.EndTime).format('YYYY-MM-DD HH:mm')
          }
          voteManageApi.editVoteBasic(_this.voteBasicForm).then(data => {
            _this.voteBasicForm.Id = data.Id
            let questionnaireId = '0'
            if (data.QuestionnaireId) {
              questionnaireId = data.QuestionnaireId
            }
            openLoading.close()
            _this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            // _this.$root.$emit('voteCheck')
            this.voteCheck()
            // _this.$root.$emit('getVoteInfo')
            this.getVoteInfo()
            if (isNext) {
              if (this.$route.name.indexOf('create') !== -1) {
                if (this.voteInfo.MeetingVerify === 1) {
                  if (_this.voteBasicForm.VoteType === 5) {
                    _this.$router.push({ name: 'createVoteBody', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  } else {
                    _this.$router.push({ name: 'createVoteProject', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  }
                } else {
                  if (_this.voteBasicForm.VoteType === 5) {
                    _this.$router.push({ name: 'createVoteQAUser', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  } else {
                    _this.$router.push({ name: 'createVoteUser', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  }
                }
              } else {
                if (this.voteInfo.MeetingVerify === 1) {
                  if (_this.voteBasicForm.VoteType === 5) {
                    _this.$router.push({ name: 'editVoteBody', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  } else {
                    _this.$router.push({ name: 'editVoteProject', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  }
                } else {
                  if (_this.voteBasicForm.VoteType === 5) {
                    _this.$router.push({ name: 'editVoteQAUser', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  } else {
                    _this.$router.push({ name: 'editVoteUser', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
                  }
                }
              }
            } else {
              if (this.$route.name.indexOf('create') !== -1) {
                _this.$router.push({ name: 'createVoteBasic', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
              } else {
                _this.$router.push({ name: 'editVoteBasic', params: { mid: _this.voteBasicForm.MeetId, vid: data.Id, qid: questionnaireId } })
              }
              this.getVoteBasicInfo()
            }
          }).catch(err => {
            openLoading.close()
            return err
          })
        } else {
          return false
        }
      })
    },
    editVoteToNext: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const openLoading = this.openLoading('正在保存…')
          voteManageApi.editVoteBasic(this.voteBasicForm).then(data => {
            this.voteBasicForm.Id = data.Id
            // this.$root.$emit('voteCheck')
            this.voteCheck()
            openLoading.close()
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!',
              customClass: 'custom_message'
            })
            this.$router.push({
              name: 'editVoteUser',
              params: { mid: this.voteBasicForm.MeetId, vid: data.Id }
            })
          }).catch(err => {
            // this.$root.$emit('voteCheck')
            this.voteCheck()
            openLoading.close()
            return err
          })
        } else {
          return false
        }
      })
    },
    editRule: function (ruleId) {
      this.$refs.editRule.openEditRule(ruleId)
    },
    submitRuleDialog: function () {
      if (this.voteBasicForm.VoteType === 3) {
        this.getScreenRules()
      } else {
        this.getRules()
      }
    },
    deleteRule: function (ruleItem) {
      this.$confirm('确认删除规则“' + ruleItem.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        this.ruleTableLoading = true
        voteRuleApi.deleteRule({
          ruleId: ruleItem.Id
        }).then(data => {
          if (this.voteBasicForm.VoteType === 3) {
            this.getScreenRules()
          } else {
            this.getRules()
          }
          this.ruleTableLoading = false
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          this.ruleTableLoading = false
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editRuleDetails: function (ruleId) {
      this.$refs.editRuleDetails.openEditRule(ruleId)
    },
    ruleItemManager: function (ruleId) {
      this.$refs.editRuleItems.openEditRuleItems(ruleId)
    },
    getRuleItemsByRuleId: function (ruleId) {
      const _this = this
      voteManageApi.getRuleItemsByRuleId({
        ruleId: ruleId
      }).then(data => {
        _this.$set(_this.voteBasicForm.DaFenRule, _this.voteBasicForm.DaFenRule.RuleItems, data)
        _this.voteBasicForm.DaFenRule.RuleItems = data
        // _this.$set(_this.voteBasicForm.DaFenRule, _this.voteBasicForm.DaFenRule.RuleItems, data)
      }).catch(err => {
        return err
      })
    },
    ruleChange: function (item) {
      const _this = this
      if (item.Id) {
        if (_this.voteBasicForm.VoteType === 0 || _this.voteBasicForm.VoteType === 2) {
          voteRuleApi.getRule({
            ruleId: item.Id
          }).then(data => {
            if (_this.voteBasicForm.VoteType === 0) {
              // _this.voteBasicForm.RuWeiRule = data
              _this.$set(_this.voteBasicForm, _this.voteBasicForm.RuWeiRule, data)
              _this.voteBasicForm.RuWeiRule.PassValue_start = data.PassValue_start
              _this.voteBasicForm.RuWeiRule.PassValue_end = data.PassValue_end
              _this.getPercent(this.voteBasicForm.RuWeiRule.PassValue_start, this.voteBasicForm.RuWeiRule.PassValue_end)
            }
            if (_this.voteBasicForm.VoteType === 2) {
              // _this.voteBasicForm.DaFenRule = data
              _this.$set(_this.voteBasicForm, _this.voteBasicForm.DaFenRule, data)
              _this.getRuleItemsByRuleId(item.Id)
            }
            // _this.editLoading = false
          }).catch(err => {
            // _this.editLoading = false
            return err
          })
        }
        if (_this.voteBasicForm.VoteType === 3) {
          _this.editLoading = true
          voteRuleApi.getScreenRule({
            ruleId: item.Id
          }).then(data => {
            // _this.voteBasicForm.ScreenRule = data
            _this.$set(this.voteBasicForm, this.voteBasicForm.ScreenRule, data)
            _this.getRuleItemsByRuleId(item.Id)
            _this.editLoading = false
          }).catch(err => {
            _this.editLoading = false
            return err
          })
        }
      } else {
        let isSelect = false
        _this.ruweiTable.forEach(function (ruleItem, index) {
          if (ruleItem.Name === item) {
            if (_this.voteBasicForm.VoteType === 0) {
              _this.voteBasicForm.RuWeiRule = ruleItem
              _this.voteBasicForm.RuWeiRule.PassValue_start = _this.voteBasicForm.RuWeiRule.PassValue.split('/')[0]
              _this.voteBasicForm.RuWeiRule.PassValue_end = _this.voteBasicForm.RuWeiRule.PassValue.split('/')[1]
              isSelect = true
            }
            if (_this.voteBasicForm.VoteType === 2) {
              _this.voteBasicForm.DaFenRule = ruleItem
              isSelect = true
            }
            if (_this.voteBasicForm.VoteType === 3) {
              _this.voteBasicForm.ScreenRule = ruleItem
              isSelect = true
            }
          }
        })
        if (!isSelect) {
          if (_this.voteBasicForm.VoteType === 0) {
            _this.voteBasicForm.RuWeiRule = {}
            _this.voteBasicForm.RuWeiRule.Name = item
            _this.voteBasicForm.RuWeiRule.PassOperator = '0'
            _this.voteBasicForm.RuWeiRule.PassValue_start = 1.00
            _this.voteBasicForm.RuWeiRule.PassValue_end = 1.00
            _this.voteBasicForm.RuWeiRule.Sort = null
          }
          if (_this.voteBasicForm.VoteType === 2) {
            _this.voteBasicForm.DaFenRule = {}
            _this.voteBasicForm.DaFenRule.Name = item
            _this.voteBasicForm.DaFenRule.DeleteMaxScore = false
            _this.voteBasicForm.DaFenRule.DeleteMinScore = false
            _this.voteBasicForm.DaFenRule.Sort = null
            _this.voteBasicForm.DaFenRule.RuleItems = []
          }
          if (_this.voteBasicForm.VoteType === 3) {
            _this.voteBasicForm.ScreenRule = {}
            _this.voteBasicForm.ScreenRule.Name = item
            _this.voteBasicForm.ScreenRule.IsAnony = false
            _this.voteBasicForm.ScreenRule.IsRemoveMaxScore = false
            _this.voteBasicForm.ScreenRule.IsRemoveMinScore = false
            _this.voteBasicForm.ScreenRule.IsDetailRule = false
            _this.voteBasicForm.ScreenRule.MinScore = 1
            _this.voteBasicForm.ScreenRule.MaxScore = 100
            _this.voteBasicForm.ScreenRule.Sort = null
            _this.voteBasicForm.DaFenRule.RuleItems = []
          }
        }
      }
    },
    voteNameBlur: function () {
      if (this.voteBasicForm.VoteType !== 1) {
        this.inputRuleName = this.voteBasicForm.VoteName
        if (this.inputRuleName.length > 0) {
          this.ruleChange(this.inputRuleName)
        }
      }
    },
    passValueChange: function () {
      this.getPercent(this.voteBasicForm.RuWeiRule.PassValue_start, this.voteBasicForm.RuWeiRule.PassValue_end)
    },
    getPercent: function (num, total) {
      /// <summary>
      /// 求百分比
      /// </summary>
      /// <param name="num">当前数</param>
      /// <param name="total">总数</param>
      num = parseFloat(num)
      total = parseFloat(total)
      if (isNaN(num) || isNaN(total)) {
        return '-'
      }
      if (num === 0) {
        num = 1
      }
      if (total === 0) {
        total = 1
      }
      this.rolePercent = total <= 0 ? '0%' : (Math.round(num / total * 10000) / 100.00) + '%'
    },
    ruleBlur: function () {
      if (this.inputRuleName.length > 0) {
        this.ruleChange(this.inputRuleName)
      }
    },
    dataFilter: function (val) {
      this.inputRuleName = val
    },
    bingRuleTypeChange: function () {
      if (this.voteBasicForm.VoteType === 0 || this.voteBasicForm.VoteType === 2) {
        this.getRules()
      }
      if (this.voteBasicForm.VoteType === 3) {
        this.getScreenRules()
      }
    },
    openEditRuleItem: function (item, action, index) {
      this.innerVisible = true
      this.ruleItemAction = action
      this.ruleItemIndex = index
      this.ruleItemForm = {}
      if (this.ruleItemAction === 'add') {
        this.ruleItemForm.MinScore = 1
        this.ruleItemForm.MaxScore = 100
        this.ruleItemForm.ScorePercent = 100
        this.ruleItemForm.IsScoringItem = true
      } else {
        this.ruleItemForm = JSON.parse(JSON.stringify(item))
      }
    },
    editRuleItem: function (formName) {
      const _this = this
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.editVoteLoading = true
          if (_this.ruleItemForm.Content) {
            _this.ruleItemForm.ContentText = _this.ruleItemForm.Content.replace(/<[^>]+>\s+(?=<)|<[^>]+>/g, '')
          }
          if (_this.ruleItemForm.ContentText) {
            if (_this.ruleItemForm.ContentText.length > 50) {
              _this.ruleItemForm.ContentText = _this.ruleItemForm.ContentText.substring(0, 50) + '……'
            }
          }
          if (!_this.ruleItemForm.Sort) {
            if (_this.voteBasicForm.DaFenRule.RuleItems.length > 0) {
              _this.ruleItemForm.Sort = parseInt(_this.voteBasicForm.DaFenRule.RuleItems[_this.voteBasicForm.DaFenRule.RuleItems.length - 1].Sort) + 1
            } else {
              _this.ruleItemForm.Sort = 1
            }
          }
          if (_this.ruleItemAction === 'add') {
            _this.voteBasicForm.DaFenRule.RuleItems.unshift(JSON.parse(JSON.stringify(_this.ruleItemForm)))
          } else {
            _this.voteBasicForm.DaFenRule.RuleItems.splice(this.ruleItemIndex, 1, JSON.parse(JSON.stringify(_this.ruleItemForm)))
          }
          for (let i = 0; i < _this.voteBasicForm.DaFenRule.RuleItems.length - 1; i++) {
            for (let j = 0; j < _this.voteBasicForm.DaFenRule.RuleItems.length - i - 1; j++) {
              if (_this.voteBasicForm.DaFenRule.RuleItems[j].Sort > _this.voteBasicForm.DaFenRule.RuleItems[j + 1].Sort) {
                const temp = _this.voteBasicForm.DaFenRule.RuleItems[j]
                _this.voteBasicForm.DaFenRule.RuleItems[j] = _this.voteBasicForm.DaFenRule.RuleItems[j + 1]
                _this.voteBasicForm.DaFenRule.RuleItems[j + 1] = temp
              }
            }
          }
          _this.innerVisible = false
          _this.editVoteLoading = false
          this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功!',
            customClass: 'custom_message'
          })
        } else {
          return false
        }
      })
    },
    deleteRuleItem: function (item, index) {
      const _this = this
      _this.$confirm('确认删除细则“' + item.Title + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        _this.editVoteLoading = true
        _this.voteBasicForm.DaFenRule.RuleItems.splice(index, 1)
        if (item.Id) {
          _this.voteBasicForm.DaFenRule.DeleteRuleItemIds.push(item.Id)
        }
        _this.editVoteLoading = false
        this.$message({
          type: 'success',
          message: '删除成功!',
          customClass: 'custom_message'
        })
      }).catch(() => {
        _this.editVoteLoading = false
        _this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    }
  },
  mounted () {
    // const _this = this
    // _this.$root.$off('editVoteStatus')
    // _this.$root.$on('editVoteStatus', (status) => {
    //   _this.$forceUpdate()
    //   _this.voteStatus = Number(status)
    //   console.log(_this.voteStatus)
    // })
  },
  created () {
    this.ruleListQuery.meetingId = this.$route.params.mid
    if (this.$route.params.vid === '0') {
      this.selectMode(0)
      this.voteBasicForm.MeetId = this.$route.params.mid
    } else {
      this.getVoteBasicInfo()
    }
    // this.$root.$emit('routeChange')
    this.routeChange()
    // this.$root.$emit('voteCheck')
    this.voteCheck()
  },
  watch: {
    $route () {
      if (this.$route.name === 'createVoteBasic' && this.$route.params.vid === '0') {
        this.voteBasicForm = {
          Id: null,
          VoteName: null,
          MeetId: this.$route.params.mid,
          VoteType: 0,
          SelectRuleId: null,
          BindRuleType: 'from',
          ScreenRule: { Id: null },
          RuWeiRule: { Id: null },
          DaFenRule: { Id: null, RuleItems: [], DeleteRuleItemIds: [] }
        }
      }
      if (this.$route.name === 'createVoteBasic' && this.$route.params.vid !== '0') {
        this.voteCheck()
      }
    }
  }
}
</script>
<style lang="less">
.el-table__row {
  cursor: pointer;
}
#selectRule .el-divider__text {
  font-size: 18px;
  font-weight: 900;
}
.main_form_body_voteBasic {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
}
.vote_type_desc {
  margin: 0px 30px;
  font-size: 10px;
}
.vote_fraction_box {
}
.vote_fraction_box .el-form-item__label {
  margin: 24px 0px 0px 0px;
}
.vote_type_divider_box {
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  height: 86px;
  margin-bottom: 32px;
}
.vote_type_divider_box span {
  width: 16px;
  margin-left: -20px;
  background-color: #fff;
  z-index: 1;
  line-height: 18px;
  font-size: 12px;
  padding: 3px;
}
.vote_type_divider {
  height: 86px;
  width: 2px;
}
</style>
